/* eslint-disable no-console */
import React from 'react';
import {AsyncButton, DatePicker, Select} from '@nike/ruxac';
import {connect} from 'react-redux';
import {laborProcessTriggerEmailAPI} from '../APIs/dataHelper';
//import Location from "./Location";
import {setBeginDateLaborProcessFilter,
    setEndDateLaborProcessFilter,
    setFormatVersionLaborProcessFilter} from '../Actions/laborProcessFilters';
import {checkForToken, login} from '../APIs/loginHelper';

export class LaborProcessFilters extends React.Component {

    render() {
        const submitFilters = () => {
            const jwt = checkForToken ();
            if (!jwt || !jwt.accessToken) {
                //redirect to SSO if no jwt present
                console.log("NO JWT");
                login ();
            }
            else {
                this.props.laborProcessTriggerEmailAPI(this.props.laborProcessFilters, jwt.accessToken, this.props.userInfo.userName);

            }
        };
        const beginDateTokenized = this.props.laborProcessFilters.beginDate.split('-');
        const endDateTokenized = this.props.laborProcessFilters.endDate.split('-');
        const maxDateTokenized = this.props.laborProcessFiltersData.maxDate.split('-');
        return (
            <div className={`filter-container-outer`}>
                <div className={'row filter-container-inner'}>
                    <div className={`col-xs-2 margin-right`}>
                        <div className="label">LABOR PROCESS
                        </div>
                    </div>
                    <div className={`col-xs-2 margin-right `}>
                        <DatePicker
                            className="filter-component"
                            autoOk={true}
                            label="*Begin Date"
                            placeholder="Please select the begin date"
                            maxDate={new Date(maxDateTokenized[0], maxDateTokenized[1] - 1, maxDateTokenized[2])}
                            value={new Date(beginDateTokenized[0], beginDateTokenized[1] - 1, beginDateTokenized[2])}
                            onChange={(value) => {
                                const valueString = (new Date(value).getFullYear() + '-' + (new Date(value).getMonth() + 1) + '-' + new Date(value).getDate());
                                this.props.setBeginDateLaborProcessFilter(valueString);
                                const checkEndDate = new Date(endDateTokenized[0], endDateTokenized[1] -1, endDateTokenized[2]);
                                if(value >= checkEndDate)
                                    this.props.setEndDateLaborProcessFilter(valueString);
                            }}
                        />
                    </div>
                    <div className={`col-xs-2 margin-right`}>
                        <DatePicker
                            className="filter-component"
                            autoOk={true}
                            label="*End Date"
                            placeholder="Please select the end date"
                            minDate={new Date(beginDateTokenized[0], beginDateTokenized[1] - 1, beginDateTokenized[2])}
                            maxDate={new Date(new Date(maxDateTokenized[0], maxDateTokenized[1] - 1, maxDateTokenized[2]))}
                            value={new Date(endDateTokenized[0], endDateTokenized[1] -1, endDateTokenized[2])}
                            onChange={(value) => {
                                const valueString = (new Date(value).getFullYear() + '-' + (new Date(value).getMonth() + 1) + '-' + new Date(value).getDate());//(moment(value).year() + '-' + (moment(value).month() + 1) + '-' + moment(value).date());
                                this.props.setEndDateLaborProcessFilter(valueString);

                            }}
                        />
                    </div>
                    <div className={`col-xs-2`}>
                        <Select
                            label="FORMAT VERSION"
                            className="filter-component"
                            options={[
                                {value : 'V1.0', label : 'V1.0'}
                            ]}
                            placeholder="V1.0"
                            allowClear
                            value={this.props.laborProcessFilters.version}
                            onChange={(value) => {
                                this.props.setFormatVersionLaborProcessFilter(value);
                            }}
                        />
                    </div>
                    <div className={`col-xs-2 submit-btn`}>

                        <AsyncButton
                            onClick={submitFilters}
                        >
                            Submit
                        </AsyncButton>
                    </div>
                </div>
                <div>
                </div>
            </div>


        );
    }
}
const mapStateToProps = (state) => {
    return {
        laborProcessFilters     : state.laborProcessFilters,
        laborProcessFiltersData : state.laborProcessFiltersData,
        userInfo                : state.userInfo
    };
};

const mapDispatchToProps = {
    laborProcessTriggerEmailAPI,
    setBeginDateLaborProcessFilter,
    setEndDateLaborProcessFilter,
    setFormatVersionLaborProcessFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(LaborProcessFilters);



// WEBPACK FOOTER //
// ./src/Components/LaborProcess.js